import Button from 'apollo-react/components/Button';
import Table from 'apollo-react/components/Table';
import PlusIcon from 'apollo-react-icons/Plus';
import React, { useEffect, useState } from 'react';

import columns from './columns.data';

export const OrderByTable = ({
  disabled,
  fieldList = [],
  currentRows = [],
  setOrderByList,
  changeDataSource,
  dataSourceObject,
  setDatasourceObject,
}) => {
  const [rows, setRows] = useState(currentRows);

  useEffect(() => {
    setRows(currentRows ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentRows)]);

  const updateRow = ({ index, newRow, action = 'edit' }) => {
    let newRows = rows;
    if (action === 'edit') {
      newRows = rows.map((row, i) => (i === index ? { ...newRow } : row));
    }
    if (action === 'delete') {
      newRows = rows.filter((_, i) => i !== index);
    }
    if (action === 'add') {
      newRows = [
        ...rows,
        { direction: 'ASC', field: '', translatedField: '', index, fieldList, updateRow },
      ];
    }
    setRows(newRows);

    const mappedRows = newRows?.map(({ field, translatedField, direction }) => ({
      field,
      translatedField,
      direction,
    }));

    setOrderByList(mappedRows);

    changeDataSource({
      dataSourceObject,
      property: 'orderBy',
      propertyValue: mappedRows,
      setDatasourceObject,
    });
  };

  return (
    <Table
      columns={columns}
      rows={rows?.map((row, index) => ({
        ...row,
        index,
        fieldList,
        updateRow,
        disabled,
      }))}
      tablePaginationProps={{ dir: 'ltr' }}
      rowsPerPageOptions={[5, 10, 15, 'All']}
      CustomHeader={() => (
        <div>
          <Button
            disabled={disabled || !fieldList?.length}
            size="small"
            variant="secondary"
            icon={PlusIcon}
            style={{ marginRight: 8 }}
            onClick={() => updateRow({ index: rows.length, action: 'add' })}
          >
            {'Add'}
          </Button>
        </div>
      )}
    />
  );
};
